import { render, staticRenderFns } from "./13.vue?vue&type=template&id=dc9a8738&scoped=true&"
import script from "./13.vue?vue&type=script&lang=js&"
export * from "./13.vue?vue&type=script&lang=js&"
import style0 from "./13.vue?vue&type=style&index=0&id=dc9a8738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9a8738",
  null
  
)

export default component.exports